




















import i18n from "@/i18n";
import { getPlayerAnalytics } from "@/services/reports/reportsService";
import { PlayerAnalytics } from "@/services/reports/types";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PlayerReportAnalyticsModal extends Vue {
    playerAnalytics = {} as PlayerAnalytics;

    open() {
        getPlayerAnalytics().then(response => {
            this.playerAnalytics = response;
            this.$bvModal.show("modal-playerAnalytics");
        });
    }

    hide() {
        this.$bvModal.hide("modal-playerAnalytics");
    }
}
